import {
  clearSelectedPlanData,
  saveSelectedDeviceDetails,
  setUnauthToAuth,
} from '../../features/selectedData/selectedDataReducer';
import { clearSelectedPlanFromConfirm } from '../../features/selectedData/persistantDataReducer';
import { emitItpStateChanged } from './itpPageTools';

export const openPlanForLine = (selectedDeviceDetails, { dispatch, navigate }) => {
  dispatch(setUnauthToAuth(false));
  dispatch(saveSelectedDeviceDetails(selectedDeviceDetails));
  dispatch(clearSelectedPlanData());
  dispatch(clearSelectedPlanFromConfirm(selectedDeviceDetails?.mtn));
  emitItpStateChanged();
  if (
    selectedDeviceDetails?.travelPassPlan ||
    selectedDeviceDetails?.monthlyPlan ||
    selectedDeviceDetails?.monthlyITPRecurring ||
    selectedDeviceDetails?.payAsYouGoLand
  ) {
    navigate('/itpplanselection');
  } else if (selectedDeviceDetails?.skipCruiseAndFlightPlans) {
    navigate('/itpskipplan');
  } else if (
    selectedDeviceDetails?.cruisePlan ||
    selectedDeviceDetails?.inflightPlan ||
    selectedDeviceDetails?.payAsYouGoSea
  ) {
    navigate('/itpcruiseplanselection');
  }
};
